const generateMapPhoneNumberSID = function (state) {
  const mapPhoneNumberSID = state.phoneNumbers.reduce(
    (acc: any, curr: any) => {
      acc[curr.phone_number] = curr.sid
      return acc
    },
    {}
  )
  state.mapPhoneNumberSID = mapPhoneNumberSID
}

export default generateMapPhoneNumberSID
